export default "__VITE_ASSET__BkAJREa8__"